export interface ChatParticipantProfile {
  id: string;
  biography?: string;
  areasOfLaw: string[];
  specialization: string[];
  fullAddress?: string;
  city?: string;
  stateProvince?: string;
  country?: string;
  languages: string[];
  education?: string;
  profilePicture?: string;
}

export interface ChatParticipant {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  role: string;
  bio?: string;
  profile?: ChatParticipantProfile;
}

export interface Message {
  id: string;
  content: string;
  senderId: string;
  sender?: ChatParticipant; // Optional because backend might not always include it
  createdAt: string;
  updatedAt: string;
}

export interface Conversation {
  id: string;
  participantIds: string[];
  participants: ChatParticipant[];
  messages: Message[];
  createdAt: string;
  updatedAt: string;
}

export interface ConversationListItem {
  id: string;
  participantIds: string[];
  participants: ChatParticipant[];
  lastMessage?: Message;
  createdAt: string;
  updatedAt: string;
}

// Legacy User interface for compatibility (deprecated - use ChatParticipant)
export interface User {
  id: string;
  name: string;
  avatar?: string;
}

// Helper interface for UI when we have participant details (now same as Conversation)
export interface ConversationWithParticipants extends Conversation {}

// Helper function to get the other participant ID from a conversation
export function getOtherParticipantId(
  conversation: Conversation,
  currentUserId: string
): string | null {
  return conversation.participantIds.find((id) => id !== currentUserId) || null;
}

// Helper function to get the other participant from a conversation with participant details
export function getOtherParticipant(
  conversation: ConversationWithParticipants | null,
  currentUserId: string
): User | null {
  if (!conversation) return null;
  return (
    conversation.participants.find(
      (participant) => participant.id !== currentUserId
    ) || null
  );
}
